import { render } from "./MathematicsDisciplinePanel.vue?vue&type=template&id=f6764032"
import script from "./MathematicsDisciplinePanel.vue?vue&type=script&lang=js"
export * from "./MathematicsDisciplinePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__